<template>
  <div class="modal-backdrop" v-if="modalStatus">
    <div class="modal">
      <div class="modal-header">
        {{ title }}
        <i class="el-icon-close" @click="changeModal"></i>
      </div>
      <div class="modal-body">
        {{ content }}
      </div>
      <div class="modal-footer">
        <span class="btn-close btn" @click="close" v-if="showCancle">{{
          cancleText ? cancleText : 'NO'
        }}</span>
        <span class="btn-confirm btn" @click="confirm">{{
          confirmText ? confirmText : 'YES'
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modal',
  props: {
    // midal标题
    title: {
      type: String,
      default: '提示'
    },
    // modal内容
    content: {
      type: String,
      default: ''
    },
    // 是否显示
    show: {
      type: Boolean,
      default: true
    },
    // 是否显示取消按钮
    showCancle: {
      type: Boolean,
      default: true
    },
    // 确认按钮文字
    confirmText: {
      type: String,
      default: '确认'
    },
    // 取消按钮文字
    cancleText: {
      type: String,
      default: '取消'
    }
  },
  data() {
    return {
      modalStatus: true
    }
  },
  methods: {
    // 关闭按钮事件
    close() {
      this.$emit('on-cancel')
    },
    // 确定按钮事件
    confirm() {
      this.$emit('on-confirm')
    },
    changeModal() {
      this.modalStatus = false
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999999;
}
.modal {
  background-color: #fff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  width: 605px;
}
.modal-header {
  width: 100%;
  height: 48px;
  box-sizing: border-box;
  background: #333;
  color: #fff;
  justify-content: space-between;
  align-items: center;
  padding: 0 23px 0 32px;
  display: flex;
  font-size: 20px;
}
.modal-footer {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 33px 32px 318px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-body {
  position: relative;
  padding: 20px;
  font-size: 22px;
  color: #222;
  text-align: center;
}

.btn {
  display: inline-block;
  width: 115px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  border-radius: 19px;
  font-size: 18px;
}
.btn-confirm {
  color: #ff6500;
  border: 1px solid #ff6500;
}

.btn-close {
  color: #979797;
  border: 1px solid #979797;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/modal.vue